import { Data } from 'effect'

class ApplicationError extends Data.TaggedError('ApplicationError')<{
  message: string
}> {}

export default ApplicationError
